import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';

const CTABanner = () => {
  const { t } = useTranslation();
  return (
    <section data-testid="cta-banner" className="py-14 lg:py-20 bg-[#1A1816] relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <motion.div className="absolute whitespace-nowrap" style={{ bottom: '10%' }}
          animate={{ x: ['0%', '-40%'] }} transition={{ duration: 25, repeat: Infinity, ease: 'linear' }}>
          <span className="text-[14vw] font-bold text-[#FAF8F5]/[0.02] tracking-[-0.05em] font-sans leading-none">
            TRANSFORM&nbsp;&nbsp;&nbsp;YOUR&nbsp;&nbsp;&nbsp;PRESENCE&nbsp;&nbsp;&nbsp;TRANSFORM
          </span>
        </motion.div>
      </div>
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-1/2 h-full bg-gradient-to-r from-[#C9A96E]/5 to-transparent" />
        <div className="absolute -top-20 right-20 w-72 h-72 bg-[#C9A96E]/5 rounded-full blur-[80px]" />
      </div>
      <div className="max-w-[800px] mx-auto px-6 lg:px-12 relative z-10 text-center">
        <motion.h2 className="text-2xl sm:text-3xl lg:text-4xl font-sans font-bold text-[#FAF8F5] leading-tight"
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          {t('cta_banner.title')}
        </motion.h2>
        <motion.p className="mt-4 text-sm sm:text-base text-[#FAF8F5]/50 max-w-md mx-auto"
          initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}>
          {t('cta_banner.sub')}
        </motion.p>
        <motion.div className="mt-8"
          initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
          <button onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
            data-testid="cta-banner-button"
            className="inline-flex items-center gap-2 bg-[#C9A96E] text-[#1A1816] px-8 py-4 text-xs font-semibold tracking-wider uppercase hover:bg-[#FAF8F5] transition-colors">
            {t('cta_banner.btn')} <ArrowRight className="w-4 h-4" />
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default CTABanner;
